import React, { useId, useRef } from 'react';
import { Box } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LogFieldCard from './LogFieldCard';

const LogTimeField = ({
  value,
  onChange,
  label = 'Time',
  placeholder = '',
  showLabel = true,
  sx = {},
  containerSx = {},
  valueSx = {},
  labelSx = {},
  iconSx = {},
  icon: Icon = AccessTimeIcon,
}) => {
  const inputId = useId();
  const inputRef = useRef(null);

  const handleOpenPicker = () => {
    const inputEl = inputRef.current;
    if (!inputEl) return;

    if (typeof inputEl.showPicker === 'function') {
      inputEl.showPicker();
      return;
    }

    inputEl.focus();
    inputEl.click();
  };

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        '& .log-time-field-native::-webkit-calendar-picker-indicator': {
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          padding: 0,
          margin: 0,
          opacity: 0,
          cursor: 'pointer',
        },
        ...containerSx,
      }}
    >
      <LogFieldCard
        label={label}
        value={value}
        placeholder={placeholder}
        onClick={handleOpenPicker}
        showLabel={showLabel}
        kind="time"
        icon={Icon}
        sx={sx}
        valueSx={valueSx}
        labelSx={labelSx}
        iconSx={iconSx}
        ariaLabel={`${label.toLowerCase()} picker`}
      />
      <input
        id={inputId}
        ref={inputRef}
        className="log-time-field-native"
        type="time"
        value={value}
        onChange={onChange}
        aria-label={`${label.toLowerCase()} picker`}
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          padding: 0,
          margin: 0,
          border: 0,
          opacity: 0.01,
          cursor: 'pointer',
          zIndex: 2,
          fontSize: '16px',
          background: 'transparent',
          color: 'transparent',
          caretColor: 'transparent',
          WebkitTapHighlightColor: 'transparent',
        }}
      />
    </Box>
  );
};

export default LogTimeField;
